// Need to use the React-specific entry point to import createApi
import type {
  AccountDetailResponse,
  GetAccountListV2Request,
  GetListResponseOfAccountListResponse,
} from 'src/api/ProactApiClient';
import {accountApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const accountApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAccountListV2: builder.query<
      GetListResponseOfAccountListResponse,
      GetAccountListV2Request
    >({
      queryFn: clientQuery(params => accountApiClient.listV2(params)),
      providesTags: ['Accounts'],
    }),
    getAccount: builder.query<AccountDetailResponse, number>({
      queryFn: clientQuery(id => accountApiClient.get(id)),
      providesTags: ['Accounts'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetAccountListV2Query, useGetAccountQuery} = accountApi;
